const CardItem = ({ item, index }) => {
	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item.id || "1"}</strong>
			</td>
			<td>{item?.name || "Muhammed"}</td>
			<td>{item?.job_title || "Software Engineer"}</td>
			<td>{item?.department?.name || "IT"}</td>
			<td>{item?.accrued_leave || 0}</td>
			<td>{Number.parseFloat(item?.provision_KWD).toFixed(3) || "-"}</td>
		</tr>
	);
};
export default CardItem;
